import { RENDER_STATUS } from '../constants/constants';
import { apiGetDownloadRendersImagesV2 } from '../helpers/api';
import { download as fileDownload } from '../common/DownloadFileController/downloadFile';
import { useState } from 'react';
import { warningToast } from "../helpers/toastHelper";
import { IMAGE_TYPE } from '../constants/renderPreviewConstants';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import JSZipUtils from '../../node_modules/jszip-utils/dist/jszip-utils.js';
import { renameDuplicateNames } from '../helpers/jsHelper.js';

export const useDownloadEntity = () => {
  const [loading, setLoading] = useState(false);

  async function download({ id, type, name, item }) {
    setLoading(true);
    if (type === 'renders-previews') {
      if(item){
        await setAngleImageUrl({is_separate:true , selectedList:[item]})
      }else{
        await apiGetDownloadRendersImagesV2({ ids: [id], fileName: name || 'downloaded-images.zip' })
      }
    }
    setLoading(false)
  }

  const handleDownloadData = (imageUrl,fileInfo, name) => {
    var zip = new JSZip();
    if (imageUrl?.length !== 0) {
      let count = 0;
      imageUrl.forEach(function (imgObj, i) {
        let url = imgObj.url;
        let angle_name = imgObj.angle_name;
        let imageType = imgObj.imageType;
        let ext = imgObj.filename.split('.').pop();
        let filename = `${"render"}_${angle_name}_${imageType}.${ext}`;
        JSZipUtils.getBinaryContent(url, function (err, data) {
          if (err) {            
            throw err; // or handle the error
          }
          if (true) {
            if (imageType === IMAGE_TYPE.STANDARD) {
              zip.folder(imgObj?.itemFileName || fileInfo?.name).file(filename, data, { binary: true });
            }
            if (imageType === IMAGE_TYPE.FILMIC) {
              zip.folder(imgObj?.itemFileName || fileInfo?.name).file(filename, data, { binary: true });
            }
            if (imageType === IMAGE_TYPE.COLOR) {
              zip.folder(imgObj?.itemFileName || fileInfo?.name).file(filename, data, { binary: true });
            }
          }
          count++;
          if (count === imageUrl.length) {
            zip.generateAsync({ type: 'blob' }).then(function (content) {
              saveAs(content, name);
              count = 0;
            });
          }
        });
      });
    }
  }

  const setAngleImageUrl = async ({ is_separate , selectedList }) => {
    let imagesData = []
     renameDuplicateNames(selectedList, 'name')?.map((arr)=> {
      let images = is_separate ? [] : [...imagesData]
      arr?.images?.map((a, i) => {
        if (a?.file !== null) {
          const u = a?.file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];
          images = [
            ...images,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType: IMAGE_TYPE.STANDARD,
              filename: filename,
              url: a?.file,
              itemFileName:arr?.name
            },
          ]
        }
        if (a?.filmic_file !== null) {
          const u = a?.filmic_file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];
  
          images = [
            ...images,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType: IMAGE_TYPE.FILMIC,
              filename: filename,
              url: a?.filmic_file,
              itemFileName:arr?.name
            },
          ]
        }
        if (a?.color_pass_file !== null) {
          const u = a?.color_pass_file.split('/');
          const f = u[u.length - 1].split('?');
          const filename = f[0];
          images = [
            ...images,
            {
              id: a?.id,
              angle_name: a?.angle_name,
              imageType: IMAGE_TYPE.COLOR,
              filename: filename,
              url: a?.color_pass_file,
              itemFileName:arr?.name
            },
          ]
        }
      });
      if(!is_separate){
        imagesData = images?.slice()
      }else{
        handleDownloadData(images,arr, arr?.name)
      }
    })
    if(!is_separate){
      handleDownloadData(imagesData,null,'render')
    }
  }

  async function download3DFilesZip(data) {
    if (data?.zip_file_details && data?.zip_file_details?.status === RENDER_STATUS.STATUS_DONE && data?.zip_file_details?.zip_file) {
      setLoading(true);
      await fileDownload({
        fileUrl:data?.zip_file_details?.zip_file,
        fileName: `${data?.name || 'downloaded-3d-files-zip'}.zip`,
        auth: false,
      });
      setLoading(false);
    } else {
      warningToast('Something went wrong!');
    }
  }

  return { download, loading, download3DFilesZip, handleDownloadData, setAngleImageUrl };
};
